import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Profile, Organization } from "@/types/directory";
import { toast } from "@/hooks/use-toast"; // Changed from Toast to toast

interface UseDirectoryDataProps {
  toast: typeof toast;
}

export const useDirectoryData = ({ toast }: UseDirectoryDataProps) => {
  const { data: profiles = [], isLoading: isLoadingProfiles } = useQuery({
    queryKey: ['directory-profiles'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('profiles')
        .select(`
          *,
          artist_categories:category_id (
            name
          )
        `);
      
      if (error) {
        toast({
          title: "Error loading profiles",
          description: error.message,
          variant: "destructive",
        });
        return [];
      }
      
      return data as Profile[];
    },
  });

  const { data: organizations = [], isLoading: isLoadingOrgs } = useQuery({
    queryKey: ['directory-organizations'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('organizations')
        .select('*');
      
      if (error) {
        toast({
          title: "Error loading organizations",
          description: error.message,
          variant: "destructive",
        });
        return [];
      }
      
      return data as Organization[];
    },
  });

  const { data: categories = [] } = useQuery({
    queryKey: ['artist-categories'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('artist_categories')
        .select('*');
      
      if (error) {
        toast({
          title: "Error loading categories",
          description: error.message,
          variant: "destructive",
        });
        return [];
      }
      
      return data;
    },
  });

  return {
    profiles,
    organizations,
    categories,
    loading: isLoadingProfiles || isLoadingOrgs,
    currentPage: 1,
    totalPages: 1,
    handlePageChange: (page: number) => {
      console.log('Page changed to:', page);
    },
  };
};